<script lang="ts">
	import Instruction from './steps/Instructions.svelte'
	import WordsRating from './steps/WordsRating.svelte'
	import {v4 as uuidv4} from 'uuid'
	import Text from './Text.svelte'
	import shuffle from 'array-shuffle'
	import instructions from './steps/Instructions'
	import Questions from './questions/Questions.svelte'
	import Loading from './Loading.svelte'

	let step = 0

	let wordsListNumber: number
	let newListAvailable: boolean
	let words: string[] = []
	let error = ""

	const getId = async () => {
		const URLquery = new URLSearchParams(document.location.search)
		const isRedo = URLquery.has('redo')
		let listId
		let nbRedo = 0
		const nbLists = 12
		if (isRedo) {
			nbRedo = Number(sessionStorage.getItem('redo')) + 1
			listId = sessionStorage.getItem('listId')
			sessionStorage.setItem('redo', nbRedo.toString())
		} else {
			const nextFormIdReq = await fetch('backend.php')
			if (nextFormIdReq.status >= 400) {
				listId = Math.floor(Math.random() * nbLists)
			} else {
				const nextFormIdJson = await nextFormIdReq.json()
				listId = nextFormIdJson.listId
			}
			sessionStorage.setItem('listId', listId)
			sessionStorage.setItem('redo', '0')
		}
		newListAvailable = nbRedo < nbLists
		wordsListNumber = listId + nbRedo

		const fetchedWords = (await import('/words/liste' + (wordsListNumber) + '.js')).default
		words = shuffle(words.concat(fetchedWords))

		if (isRedo) {
			uuid = sessionStorage.getItem('session-id')
		} else {
			sessionStorage.setItem('session-id', uuid);
		}

		return {
			newListAvailable,
		}
	}

	getId()

	let uuid = uuidv4();

	const nextStep = async () => {
		step++
		if (step === 5) {
			await fetch("end.php/?list=" + wordsListNumber)
			window.location.replace('https://www.limesurvey.cifss.ulaval.ca/index.php/199626/lang-fr')
		}
	}

	let practiceWords: string[] = [
		"pieuvre",
        "aventure",
        "cannelle",
        "cheminement",
        "gourde"
	]

	practiceWords = shuffle(practiceWords)

</script>

{#if !error}
	{#if newListAvailable}
		{#if step === 0}
			<Instruction instructions={instructions} on:done={nextStep}/>
		{:else if step === 1}
			<Text on:done={nextStep}>On commence avec une petite pratique.</Text>
		{:else if step === 2}
			<WordsRating words={practiceWords} on:done={nextStep} {uuid} listNumber={12} practice={true} let:word>
				<div style="text-align: center;">
					<Questions {word} />
				</div>
			</WordsRating>
		{:else if step === 3}
			<Text on:done={nextStep}>Très bien ! Êtes-vous prêt(e) à commencer ? Appuyez sur SUIVANT pour commencer. </Text>
		{:else if step === 4}
			<WordsRating {words} on:done={nextStep} {uuid} listNumber={wordsListNumber} let:word>
				<Questions {word} />
			</WordsRating>
		{:else if step === 5}
		<div style="height: 100%; width:100%; display:flex">
			<Loading />
		</div>
		{/if}
	{:else}
		Wow! Nous ne pensions pas que vous vous rendriez jusque là. Vous avez épuisé la liste de mots! Merci de votre participation.
	{/if}
{:else}
	<div style="height: 100%; width:100%; display:flex">
		<Loading />
	</div>
{/if}